<mat-sidenav-container class="sidenav-container " fullscreen>
  <mat-sidenav #drawer class="sidenav" fixedInViewport="true"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="!(isHandset$ | async)">

    <img (click)="goHome(); closeNav()" class="logo-image" src="../../assets/img/frigg-icon-150x42.png" alt="">


    <mat-nav-list class="menu-list" *ngIf="(user$ | async) as user; else login">
      <mat-form-field class="company-selector">

        <mat-select (selectionChange)="changeCompany($event)" [(ngModel)]="selectedCompany" name="companySelector"
          #mode>
          <mat-option *ngFor="let company of companies$ | async" [value]="company.companyId">{{company.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <a mat-list-item class="menu-item" routerLink="/dashboard/sites" (click)="closeNav()">
        <mat-icon matListItemIcon class="menu-item-icon">business</mat-icon>
        <div class="spacer">Sites</div>
      </a>

      <a mat-list-item class="menu-item" *ngIf="orderPerimission == true" routerLink="/dashboard/orders"
        (click)="closeNav()">
        <mat-icon matListItemIcon class="menu-item-icon">attach_money</mat-icon>
        <div class="spacer">Orders</div>
      </a>
      <a mat-list-item class="menu-item" *ngIf="orderPerimission == true" routerLink="/dashboard/grafana-orders"
        (click)="closeNav()">
        <mat-icon matListItemIcon class="menu-item-icon">dashboard</mat-icon>
        <div class="spacer">Sales Dashboard</div>
      </a>
            <a mat-list-item class="menu-item" *ngIf="orderPerimission == true" routerLink="/dashboard/my-tasks"
        (click)="closeNav()">
        <mat-icon matListItemIcon class="menu-item-icon">checklist</mat-icon>
        <div class="spacer">My Tasks</div>
      </a>
      <!-- <a mat-list-item class="menu-item" *ngIf="overview == true"  routerLink="/dashboard/overview">
        <mat-icon matListItemIcon>density_small</mat-icon>
        <div class="spacer">Overview</div>
      </a> -->
      <!-- <a mat-list-item class="menu-item" routerLink="/dashboard/systeminfo" (click)="closeNav()">
        <mat-icon matListItemIcon class="menu-item-icon">business</mat-icon>
        <div class="spacer">Systems</div>
      </a> -->
      <!-- Customer-facing / commercial work: the kundekort and everything downstream of it
           (mapping feeds billing, employees are what billing counts). -->
      <a mat-list-item class="menu-item has-submenu" [matMenuTriggerFor]="customers" *ngIf="_isSuperAdmin">
        <mat-icon matListItemIcon class="menu-item-icon">badge</mat-icon>
        <div class="spacer">CRM</div>
      </a>

      <mat-menu #customers="matMenu" class="sub-menu">
        <a mat-list-item class="menu-item" routerLink="/dashboard/kundekort" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">business</mat-icon>
          <div class="spacer">Customers</div>
        </a>
        <a mat-list-item class="menu-item" routerLink="/dashboard/contacts" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">contacts</mat-icon>
          <div class="spacer">Contacts</div>
        </a>
        <a mat-list-item class="menu-item" routerLink="/dashboard/customer-mapping" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">hub</mat-icon>
          <div class="spacer">Customer Mapping</div>
        </a>
        <a mat-list-item class="menu-item" routerLink="/dashboard/employees" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">groups</mat-icon>
          <div class="spacer">Employees</div>
        </a>
        <a mat-list-item class="menu-item" routerLink="/dashboard/billing" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">receipt_long</mat-icon>
          <div class="spacer">Billing</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="_canSeePowerOfficeLog" routerLink="/dashboard/poweroffice-log" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">history</mat-icon>
          <div class="spacer">PowerOffice log</div>
        </a>
      </mat-menu>






      <a mat-list-item class="menu-item has-submenu" [matMenuTriggerFor]="products"
        *ngIf="productPerimission == true || categoryPermission == true || productRegulering == true || campaignPermission == true">
        <mat-icon matListItemIcon class="menu-item-icon">fastfood</mat-icon>
        <div class="spacer">Products</div>
      </a>

      <mat-menu #products="matMenu">

        <a mat-list-item class="menu-item" *ngIf="productPerimission == true" routerLink="/dashboard/products"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">fastfood</mat-icon>
          <div class="spacer">Products</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="categoryPermission == true" routerLink="/dashboard/category"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">category</mat-icon>
          <div class="spacer">Category</div>
        </a>

        <a mat-list-item class="menu-item" *ngIf="productRegulering == true" routerLink="/dashboard/regulering"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">find_replace</mat-icon>
          <div class="spacer">Regulation</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="campaignPermission == true" routerLink="/dashboard/notification"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">block</mat-icon>
          <div class="spacer">Stockout</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="campaignPermission == true" routerLink="/dashboard/kampanje"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">campaign</mat-icon>
          <div class="spacer">Campaign</div>
        </a>

      </mat-menu>

      <!-- <button mat-button>Animal index</button>
       -->


      <a mat-list-item class="menu-item has-submenu" [matMenuTriggerFor]="support" *ngIf="supportPermission == true">
        <mat-icon matListItemIcon class="menu-item-icon">support</mat-icon>
        <div class="spacer">Support</div>
      </a>



      <!-- Technical ops only — commercial pages live under Customers, governance under Settings. -->
      <mat-menu #support="matMenu" class="sub-menu">

        <a mat-list-item class="menu-item" routerLink="/dashboard/grafana-support" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">monitor_heart</mat-icon>
          <div class="spacer">Monitoring</div>
        </a>

        <a mat-list-item class="menu-item" routerLink="/dashboard/alertmanager" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">add_alert</mat-icon>
          <div class="spacer">Alert Manager</div>
        </a>

        <a mat-list-item class="menu-item" routerLink="/dashboard/faults" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">report_problem</mat-icon>
          <div class="spacer">Faults</div>
        </a>
        <a mat-list-item class="menu-item" routerLink="/dashboard/support/sim-list" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">sim_card</mat-icon>
          <div class="spacer">SIM Cards</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="_isSuperAdmin" routerLink="/dashboard/portal-access"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">badge</mat-icon>
          <div class="spacer">Portal Access</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="_isSuperAdmin" routerLink="/dashboard/parent-refunds"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">undo</mat-icon>
          <div class="spacer">Parent Refunds</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="_isSuperAdmin" (click)="openJofemarLicenseRenewal()">
          <mat-icon matListItemIcon class="menu-item-icon">local_drink</mat-icon>
          <div class="spacer">License Renewal</div>
        </a>
        <a mat-list-item class="menu-item" routerLink="/dashboard/coupons" (click)="closeNav()" *ngIf="_isSuperAdmin">
          <mat-icon matListItemIcon class="menu-item-icon">local_offer</mat-icon>
          <div class="spacer">Coupons</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="campaignPermission == true" routerLink="/dashboard/announcement"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">chat
          </mat-icon>
          <div class="spacer">Announcement</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="_isSuperAdmin" (click)="openSurveyForms()">
          <mat-icon matListItemIcon class="menu-item-icon">poll</mat-icon>
          <div class="spacer">Surveys</div>
        </a>
        <a mat-list-item class="menu-item" routerLink="/dashboard/system-list" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">list_alt</mat-icon>
          <div class="spacer">System List</div>
        </a>
      </mat-menu>

      <a mat-list-item class="menu-item has-submenu" [matMenuTriggerFor]="reports"
        *ngIf="orderPerimission == true || companyReportPermission == true || salesReportPermission == true">
        <mat-icon matListItemIcon class="menu-item-icon">density_small</mat-icon>
        <div class="spacer">Reports</div>
      </a>

      <mat-menu #reports="matMenu">



        <a mat-list-item class="menu-item" *ngIf="orderPerimission == true" routerLink="/dashboard/ordersreport"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">attach_money</mat-icon>
          <div class="spacer">Order Report</div>
        </a>

        <a mat-list-item class="menu-item" *ngIf="companyReportPermission == true" routerLink="/dashboard/companyreport"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">store</mat-icon>
          <div class="spacer">Company<br>Report</div>
        </a>

        <a mat-list-item class="menu-item" *ngIf="salesReportPermission == true" routerLink="/dashboard/salesreport"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">point_of_sales</mat-icon>
          <div class="spacer">Sale Report</div>
        </a>
        <a mat-list-item class="menu-item" routerLink="/dashboard/planner" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">delete</mat-icon>
          <div class="spacer">Svinn Report</div>
        </a>
      </mat-menu>

      <a mat-list-item class="menu-item has-submenu" [matMenuTriggerFor]="stocking"
        *ngIf="stockingPermisson == true || _isSuperAdmin">
        <mat-icon matListItemIcon class="menu-item-icon">widgets</mat-icon>
        <div class="spacer">Stocking</div>
      </a>

      <mat-menu #stocking="matMenu">
        <a mat-list-item class="menu-item" *ngIf="stockingPermisson == true" routerLink="/dashboard/menus"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">list</mat-icon>
          <div class="spacer">Menus</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="extraDeliveriesPermission == true"
          routerLink="/dashboard/extra-delivery" (click)="closeNav()"
          [matTooltip]="pendingCateringCount > 0 ? pendingCateringCount + ' møtemat order(s) waiting for approval' : ''">
          <mat-icon matListItemIcon class="menu-item-icon">room_service</mat-icon>
          <div class="spacer">Extra deliveries
          </div>
          <span class="nav-badge" *ngIf="pendingCateringCount > 0">{{ pendingCateringCount }}</span>
        </a>
        <a mat-list-item class="menu-item" *ngIf="systemConfigsPermission==true"
          routerLink="/dashboard/system-stocking-config" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">build</mat-icon>
          <div class="spacer">System config</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="stockingPermisson == true || _isSuperAdmin"
          routerLink="/dashboard/product-types" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">category</mat-icon>
          <div class="spacer">Product Types</div>
        </a>
        <!-- Inventory Details hidden: its backend (frigg-stocking on the Lightsail
             server, api.henther.no/stocking/v1) was stopped 2026-11-03, unused.
             Route kept in app.routing.module.ts. -->
        <!-- <a mat-list-item class="menu-item" routerLink="/dashboard/inventory-details" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">inventory_2</mat-icon>
          <div class="spacer">Inventory Details</div>
        </a> -->
      </mat-menu>

      <!-- Delivery: route templates feed the driver app; driver accounts are
           for super-admins and driver managers because the claim they carry governs data access. -->
      <a mat-list-item class="menu-item has-submenu" [matMenuTriggerFor]="delivery"
        *ngIf="stockingPermisson == true || _isSuperAdmin || _isDriverManager">
        <mat-icon matListItemIcon class="menu-item-icon">local_shipping</mat-icon>
        <div class="spacer">Delivery</div>
      </a>

      <mat-menu #delivery="matMenu">
        <a mat-list-item class="menu-item" *ngIf="stockingPermisson == true || _isSuperAdmin"
          routerLink="/dashboard/delivery/overview" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">today</mat-icon>
          <div class="spacer">Delivery today</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="stockingPermisson == true || _isSuperAdmin"
          routerLink="/dashboard/delivery/routes" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">alt_route</mat-icon>
          <div class="spacer">Routes</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="stockingPermisson == true || _isSuperAdmin"
          routerLink="/dashboard/delivery/dispatch" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">monitor_heart</mat-icon>
          <div class="spacer">Dispatch</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="stockingPermisson == true || _isSuperAdmin"
          routerLink="/dashboard/delivery/issues" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">report_problem</mat-icon>
          <div class="spacer">Issues</div>
        </a>
        <a mat-list-item class="menu-item" *ngIf="_isSuperAdmin || _isDriverManager" routerLink="/dashboard/delivery/drivers"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">badge</mat-icon>
          <div class="spacer">Drivers</div>
        </a>
      </mat-menu>

      <a mat-list-item class="menu-item has-submenu" [matMenuTriggerFor]="settings"
        *ngIf="_isSuperAdmin || routinesPermission == true">
        <mat-icon matListItemIcon class="menu-item-icon">settings</mat-icon>
        <div class="spacer">Settings</div>
      </a>

      <mat-menu #settings="matMenu">
        <a mat-list-item class="menu-item" *ngIf="_isSuperAdmin" routerLink="/dashboard/admin" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">how_to_reg</mat-icon>
          <div class="spacer">Admin Board</div>
        </a>

        <a mat-list-item class="menu-item" *ngIf="routinesPermission == true" routerLink="/dashboard/task"
          (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">update</mat-icon>
          <div class="spacer">Routines</div>
        </a>
        <a mat-list-item class="menu-item" routerLink="/dashboard/setting" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">tune</mat-icon>
          <div class="spacer">General</div>
        </a>
        <a mat-list-item class="menu-item" routerLink="/dashboard/email" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">email</mat-icon>
          <div class="spacer">Email</div>
        </a>
        <a mat-list-item class="menu-item" routerLink="/dashboard/kiosk-tablets" (click)="closeNav()">
          <mat-icon matListItemIcon class="menu-item-icon">tablet_android</mat-icon>
          <div class="spacer">Kiosk tablets</div>
        </a>
        <a mat-list-item class="menu-item" routerLink="/dashboard/audit-logs" (click)="closeNav()"
          *ngIf="_isSuperAdmin">
          <mat-icon matListItemIcon class="menu-item-icon">history</mat-icon>
          <div class="spacer">Audit Log</div>
        </a>
        <a mat-list-item class="menu-item" (click)="openGrafana()">
          <mat-icon matListItemIcon class="menu-item-icon">dashboard</mat-icon>
          <div class="spacer">Grafana</div>
        </a>
      </mat-menu>


      <!-- <a mat-list-item  routerLink="/dashboard/reports">
        <mat-icon  matListItemIcon>density_small</mat-icon>
        <div class="spacer">Reports</div>
      </a> -->
      <!-- <a mat-list-item *ngIf="campaignPermission == true" routerLink="/dashboard/week">
        <mat-icon matListItemIcon>campaign</mat-icon>
        <div class="spacer">week</div>
      </a>
      <a mat-list-item *ngIf="campaignPermission == true" routerLink="/dashboard/menu">
        <mat-icon matListItemIcon>campaign</mat-icon>
        <div class="spacer">menu</div>
      </a> -->



      <!-- <a mat-list-item *ngIf="lastConnectionPermisson != false" routerLink="/dashboard/machine-mapping">
        <mat-icon matListItemIcon>connected_tv</mat-icon>
        <div class="spacer">LastConnection</div>
      </a> -->

      <hr />



      <a mat-list-item class="menu-item" (click)="onLogout()">
        <mat-icon matListItemIcon class="menu-item-icon">directions_run</mat-icon>
        <div matListItemTitle class="spacer">Logout</div>
      </a>
      <hr>
      <mat-toolbar>
        <div class="user">{{ user.email }}</div>
      </mat-toolbar>
    </mat-nav-list>
    <ng-template #login>
      <mat-nav-list>
        <a mat-list-item routerLink="/signin" (click)="closeNav()">
          <mat-icon>exit_to_app</mat-icon>
          <div class="spacer"></div>Login
        </a>
      </mat-nav-list>
    </ng-template>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar class="header" *ngIf="(isHandset$ | async)">

      <div class="logo">
        <img (click)="goHome(); closeNav()" class="logo-image-small" src="../../assets/img/frigg-icon-150x42.png"
          alt="">
      </div>
      <div class="spacer"></div>
      <button class="theme-button" type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="(isHandset$ | async)">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>


<!--

    <app-admin-dashboard ></app-admin-dashboard> 
-->